module.exports = __webpack_public_path__ + "96e917333fb295425f8cd79e2c225288.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/checkout/en/cib_bank.png
// module id = ./app/images/checkout/en/cib_bank.png
// module chunks = 40